import React, { useState } from "react";
import OpenBetsChartTable from "../tables/OpenBetsChartTable";
import { successMsg } from "../SuccessHandler";
import Loading from "../Loading";
import SiteConfig from "../../constants/SiteConfig";
import { useUpdateFunctions } from "../../functions";
import ConfirmDialog from "../utilities/ConfirmDialog";
import Rights from "../../constants/Rights";

const ModalOpenBetsChart = ({
  openBetsChartInfo,
  setOpenBetsChartInfo,
  userInfo,
  wagerTypeId,
  voidTickets,
  callTicketVoidListFrom,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
  getCharts,
}) => {
  const { ticketVoid } = useUpdateFunctions();
  const [loading, setLoading] = useState(false);
  const userRightsList = JSON.parse(localStorage.getItem("UserRights")) || [];

  let riskAmountWagers = [],
    totalAtRisk;

  openBetsChartInfo.forEach((data, i) => {
    riskAmountWagers.push(parseInt(data.TotalStake));
  });

  totalAtRisk = riskAmountWagers.reduce((a, b) => a + b, 0);

  //CAMBIAR AL NUEVO MÉTODO
  const voidTicket = (ticketID, player, idCall) => {
    ConfirmDialog(`Do you want to <strong>Void</strong> the ticket?`).then(
      async (result) => {
        if (result.isConfirmed) {
          setLoading(true);
          const res = await ticketVoid(
            {
              Session: "",
              Player: player,
              TicketID: ticketID,
              IDCall: idCall,
              LocalApp: true,
              VoidReason: SiteConfig.VOID_REASON,
              IDUser: userInfo.IdUser,
              AppSystem: SiteConfig.SYSTEM_ID,
            },
            userInfo.LogonSessionID,
          );

          if (res && !res.error) {
            successMsg("Delete Ticket");
            openBetsChartInfo.forEach((data, i) => {
              if (data.TicketID === ticketID) {
                openBetsChartInfo.splice(i, 1);
              }
            });
          }
          setLoading(false);
        }
      },
    );
  };

  const closeModal = () => {
    setSelectedTicketsVoidScore([]);
    setOpenBetsChartInfo([]);
    setSelectAllTickets(false);
    getCharts(wagerTypeId);
  };

  return (
    <>
      {loading && <Loading />}
      <div
        className="modal fade bd-example-modal-md"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
        id="openBetsChartModal"
        style={{ maxHeight: "800px" }}
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header headerModals">
              <h5
                className="modal-title h4"
                id="myLargeModalLabel"
                style={{
                  width: "100%",
                  textAlign: "center",
                }}
              >
                Open Bets
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => closeModal()}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <OpenBetsChartTable
                openBetsChartInfo={openBetsChartInfo}
                voidTicket={voidTicket}
                voidTickets={voidTickets}
                callTicketVoidListFrom={callTicketVoidListFrom}
                selectedTicketsVoidScore={selectedTicketsVoidScore}
                setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
                selectAllTickets={selectAllTickets}
                setSelectAllTickets={setSelectAllTickets}
                scoreTickets={scoreTickets}
                setCallTicketVoidListFrom={setCallTicketVoidListFrom}
              />
            </div>
            <div
              className="modal-footer"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ color: "#a6a6a6" }} className="text-left">
                {openBetsChartInfo.length} Wager(s)
                <span style={{ marginLeft: "50px" }}>
                  At Risk: $ {totalAtRisk}
                </span>
              </div>
              <div style={{ textAlign: "right" }}>
                {userRightsList.find(
                  (right) => right.FormName === Rights.FRM_VOID_TICKET,
                ) && (
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() =>
                      voidTickets("OBChart", selectedTicketsVoidScore)
                    }
                  >
                    Void Selected Tickets
                  </button>
                )}
                {userRightsList.find(
                  (right) => right.FormName === Rights.FRM_SCORE_TICKETS,
                ) && (
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={() =>
                      scoreTickets("OBChart", selectedTicketsVoidScore)
                    }
                    style={{ marginLeft: "10px" }}
                  >
                    Score Selected Tickets
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => closeModal()}
                  style={{ marginLeft: "10px" }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalOpenBetsChart;
